const config = {
    //url_api: "http://localhost:8888/facturecr-backend/public/api",
    //url_files: "http://localhost:8888/facturecr-backend/public/files/",
    //url_api: 'https://api2-stag.facturecr.com/facturecr-backend/public/api',
    //url_files: "https://api2-stag.facturecr.com/facturecr-backend/public/files/",
    //url_api: 'https://api2.facturecr.com/digital-bill-backend/public/api',
    //url_files: "https://api2.facturecr.com/digital-bill-backend/public/files/",
    url_api: "https://erp.facturecr.com/facturecr-backend/public/api",
    url_files: "https://erp.facturecr.com/facturecr-backend/public/files/"
    };
    export default config;